export const getLinkInlineButton = (theme)=>({
        base: {
            color: theme.button.link.default,
            backgroundColor: 'transparent',
            border: 'none',
            boxShadow: 'none',
            padding: theme.spacing(2, 0),
            minHeight: 'unset',
            '&:hover': {
                color: theme.button.link.hover,
                backgroundColor: 'transparent',
                boxShadow: 'none'
            },
            '&:active, &:focus:not(:focus-visible)': {
                backgroundColor: 'transparent',
                outline: 'none'
            },
            '&:focus': {
                outline: `2.5px solid ${theme.button.focused.default}`,
                outlineOffset: 4,
                background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.00) 100%)',
                backgroundBlendMode: 'lighten'
            }
        },
        active: {},
        isLoading: {},
        disabled: {
            backgroundColor: 'transparent',
            color: theme.text.interactive.disabled,
            cursor: 'not-allowed',
            boxShadow: 'none',
            '&:hover': {
                backgroundColor: 'none'
            },
            '&:active, &:focus:not(:focus-visible)': {
                outline: 'none',
                boxShadow: 'none'
            },
            svg: {
                color: theme.button.ghost.disabled
            }
        }
    });

//# sourceMappingURL=linkInline.js.map